"use strict";

angular.module("core")
.controller("abstractFormatNumberController", function(_this, $scope, lengthIndexMapping) {
    var unregister = $scope.$watch(function() {
        return _this.number;
    }, function() {
        if (!_this.ignoreFormat && _this.number) {
            unregister();
            $scope.numbers = _this.number.split("-");
            if (lengthIndexMapping.hasOwnProperty($scope.numbers.length)) {
                $scope.shortNumberIndex = lengthIndexMapping[$scope.numbers.length];
            }
        }
    }, true);
});




//////////////////
// WEBPACK FOOTER
// ./core/format-number/abstract-format-number.controller.js
// module id = 404
// module chunks = 0